import Fuse from "fuse.js";
import { remove as removeDiacritics } from "diacritics";

export const IMAGE_BASE_URI =
  "https://payments.ipaygh.com/app/webroot/img/products/";

function flatten(array) {
  return array.reduce(
    (flat, toFlatten) =>
      flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten),
    []
  );
}

export function getValuesForKey(key, item) {
  const keys = key.split(".");
  let results = [item];
  keys.forEach((_key) => {
    let tmp = [];
    results.forEach((result) => {
      if (result) {
        if (result instanceof Array) {
          const index = parseInt(_key, 10);
          if (!isNaN(index)) {
            return tmp.push(result[index]);
          }
          result.forEach((res) => {
            tmp.push(res[_key]);
          });
        } else if (result && typeof result.get === "function") {
          tmp.push(result.get(_key));
        } else {
          tmp.push(result[_key]);
        }
      }
    });

    results = tmp;
  });

  // Support arrays and Immutable lists.
  results = results.map((r) => (r && r.push && r.toArray ? r.toArray() : r));
  results = flatten(results);

  return results.filter((r) => typeof r === "string" || typeof r === "number");
}

export function searchStrings(
  strings,
  term,
  { caseSensitive, fuzzy, sortResults, normalize } = {}
) {
  strings = strings.map((e) => {
    const str = e.toString();
    return (normalize && removeDiacritics(str)) || str;
  });

  try {
    if (fuzzy) {
      if (typeof strings.toJS === "function") {
        strings = strings.toJS();
      }
      const fuse = new Fuse(
        strings.map((s) => {
          return { id: s };
        }),
        { keys: ["id"], id: "id", caseSensitive, shouldSort: sortResults }
      );
      return fuse.search(term).length;
    }
    return strings.some((value) => {
      try {
        if (!caseSensitive) {
          value = value.toLowerCase();
        }
        if (value && value.search(term) !== -1) {
          return true;
        }
        return false;
      } catch (e) {
        return false;
      }
    });
  } catch (e) {
    return false;
  }
}

export function createFilter(term, keys, options = {}) {
  return (item) => {
    if (term === "") {
      return true;
    }

    if (!options.caseSensitive) {
      term = term.toLowerCase();
    }

    if (options.normalize) {
      term = removeDiacritics(term);
    }

    const terms = term.split(" ");

    if (!keys) {
      return terms.every((term) => searchStrings([item], term, options));
    }

    if (typeof keys === "string") {
      keys = [keys];
    }

    return terms.every((term) => {
      // allow search in specific fields with the syntax `field:search`
      let currentKeys;
      if (term.indexOf(":") !== -1) {
        const searchedField = term.split(":")[0];
        term = term.split(":")[1];
        currentKeys = keys.filter(
          (key) => key.toLowerCase().indexOf(searchedField) > -1
        );
      } else {
        currentKeys = keys;
      }

      return currentKeys.some((key) => {
        const values = getValuesForKey(key, item);
        return searchStrings(values, term, options);
      });
    });
  };
}

export const keepNumbersOnly = (value) => value.replace(/[^0-9]/g, "");

export function decodeBase64Image(dataString) {
  var matches = dataString.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/),
    response = {};

  if (matches?.length !== 3) {
    return new Error("Invalid input string");
  }

  response.type = matches[1];
  response.data = new Buffer(matches[2], "base64");

  return response;
}

export const getBase64 = (file) => {
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.addEventListener("load", () => resolve(String(reader.result)));
    reader.readAsDataURL(file);
  });
};

const paymentOptions = [
  {
    name: "CASH",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-CASH.png",
    label: "CASH",
  },
  {
    name: "INVPAY",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-GCBMM.png",
    label: "INVOICE",
  },
  {
    name: "QRPAY",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-QRPAY.png",
    label: "GHQR PAY",
  },
  {
    name: "BNKTR",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-BNKTR.png",
    label: "BANK TRANSFER",
  },
  {
    name: "MTNMM",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-MTNMM.png",
    label: "MTN MOBILE MONEY",
  },
  {
    name: "TIGOC",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-TIGOC.png",
    label: "AIRTELTIGO MONEY",
  },
  {
    name: "VODAC",
    img: " https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-VODAC.png",
    label: "VODAFONE CASH",
  },
  {
    name: "GCBMM",
    img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-GCBMM.png",
    label: "GCB MOBILE MONEY",
  },
  // { name: "VISAG", img: "https://payments2.ipaygh.com/app/webroot/img/logo/IPAY-VISAG.png", label: "VISA AND MASTERCARD" },
];

export const paymentOptionNames = paymentOptions.reduce(
  (acc, val) => ({
    ...acc,
    [val?.name]: val?.label,
  }),
  {}
);

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
